import axios from 'axios';

const API_URL = '/api/target-market';

// Configure axios to send credentials with requests
axios.defaults.withCredentials = true;

const targetMarketService = {
  /**
   * Generate broad market segments
   */
  async generateSegments() {
    try {
      const response = await axios.post(`${API_URL}/generate-segments`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to generate segments'
      };
    }
  },

  /**
   * Generate niches for selected segments
   */
  async generateNiches(segmentIds) {
    try {
      const response = await axios.post(`${API_URL}/generate-niches`, {
        segment_ids: segmentIds
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to generate niches'
      };
    }
  },

  /**
   * Get all segments
   */
  async getSegments(batchId = null) {
    try {
      const url = batchId ? `${API_URL}/segments?batch_id=${batchId}` : `${API_URL}/segments`;
      const response = await axios.get(url);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get segments'
      };
    }
  },

  /**
   * Get niches by segment
   */
  async getNiches(segmentId = null) {
    try {
      const url = segmentId ? `${API_URL}/niches?segment_id=${segmentId}` : `${API_URL}/niches`;
      const response = await axios.get(url);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get niches'
      };
    }
  },

  /**
   * Set primary niche
   */
  async setPrimaryNiche(nicheId) {
    try {
      const response = await axios.post(`${API_URL}/set-primary`, {
        niche_id: nicheId
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to set primary niche'
      };
    }
  },

  /**
   * Get primary niche
   */
  async getPrimaryNiche() {
    try {
      const response = await axios.get(`${API_URL}/primary`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get primary niche'
      };
    }
  }
};

export default targetMarketService;
